import { PublicPagesTranslate } from './publicPagesTranslate.model';

const publicPagesTranslatePTBR: PublicPagesTranslate = {
  sign: {
    loading: 'Carregando contrato…',
    legalNotice:
      'Assinatura eletrônica válida conforme a MP 2.200-2/2001. O aceite é registrado com data, hora e endereço IP.',
    notFound: {
      title: 'Link inválido ou expirado',
      message:
        'Não encontramos este contrato. O link pode ter expirado ou estar incorreto.',
    },
    expired: {
      title: 'Link expirado',
      message:
        'O prazo para assinar este contrato expirou. Entre em contato com o estúdio para receber um novo link.',
    },
    canceled: {
      title: 'Solicitação cancelada',
      message: 'Esta solicitação de assinatura foi cancelada pelo estúdio.',
    },
    accepted: {
      title: 'Contrato assinado',
      message: 'Este contrato foi assinado eletronicamente em {{date}}.',
    },
    ready: {
      title: 'Assinatura eletrônica de contrato',
      description: 'Revise os dados abaixo e assine eletronicamente.',
      templateLabel: 'Contrato',
      leadLabel: 'Cliente',
      viewPdf: 'Ver contrato (PDF)',
    },
    form: {
      signerName: 'Nome completo',
      signerDocument: 'CPF (opcional)',
      agree: 'Li e concordo com os termos do contrato',
      submit: 'Assinar eletronicamente',
      conflictError:
        'Não foi possível registrar a assinatura. O contrato pode ter sido alterado ou já assinado. Recarregue a página e tente novamente.',
      validation: {
        signerNameRequired: 'Informe seu nome completo',
        signerNameMaxLength: 'O nome deve ter no máximo 256 caracteres',
        signerDocumentInvalid: 'Informe um CPF válido',
        agreedRequired: 'Você precisa concordar com os termos para assinar',
      },
    },
  },
  leadForm: {
    loading: 'Carregando formulário…',
    title: 'Entre em contato',
    description: 'Preencha o formulário e {{studioName}} entrará em contato.',
    submit: 'Enviar',
    submitError: 'Não foi possível enviar. Tente novamente.',
    notFound: {
      title: 'Formulário indisponível',
      message: 'Este formulário não está mais disponível ou o link é inválido.',
    },
    success: {
      title: 'Recebido!',
      message: 'Obrigado pelo contato. {{studioName}} retornará em breve.',
    },
    fields: {
      website: 'Website',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      instagram: 'Instagram',
      source: 'Como nos conheceu?',
      notes: 'Mensagem',
    },
    validation: {
      nameRequired: 'Informe seu nome',
      nameMaxLength: 'O nome deve ter no máximo 256 caracteres',
      emailRequired: 'Informe seu e-mail',
      emailInvalid: 'Informe um e-mail válido',
      phoneMaxLength: 'O telefone deve ter no máximo 32 caracteres',
      instagramMaxLength: 'O Instagram deve ter no máximo 128 caracteres',
      notesMaxLength: 'A mensagem deve ter no máximo 2000 caracteres',
    },
  },
};

export default publicPagesTranslatePTBR;
